const DonationsActionTypes = {
  SET_DONATION_TOKEN: 'SET_DONATION_TOKEN',
};
export default DonationsActionTypes;
